import { ApiError } from '../api/client';
import { t } from './strings';

/**
 * Map an API/network error to operator-facing Finnish. Known codes get their
 * canonical copy; a 4xx with a server-provided message (e.g. korttitoimitus /
 * migration validation, written in Finnish by the API) is shown as-is so the
 * operator sees the actionable detail. Everything else — incl. 5xx, whose
 * messages are internal — falls back to the generic retry copy.
 */
export function apiErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    const detail = err.status < 500 && typeof err.body.message === 'string' && err.body.message.trim()
      ? err.body.message
      : null;
    // bad_request messages are authored in Finnish by our API (validation
    // detail like missing Excel columns) — more useful than the canned copy.
    if (err.body.code === 'bad_request' && detail) return detail;
    const m = t.errors.byCode[err.body.code];
    if (m) return m;
    if (detail) return detail;
  }
  return t.errors.generic;
}
